import { filterOperatorRegExp } from "@/lib/filters/filterOperatorRegExp";
import { isFilterOperator } from "@/lib/filters/isFilterOperator";

/**
 * Processes the filter value by splitting it based on the filter operator regular expression,
 * trimming each part, and filtering out empty values and filter operators.
 * @example
 * processFilterValue("foo OR bar") // ["foo", "bar"]
 * processFilterValue("foo OR bar OR") // ["foo", "bar"]
 */
export const processFilterValue = (value: string | number) => {
  const parts = value
    .toString()
    .split(filterOperatorRegExp)
    .map((part) => part.trim())
    .filter((val) => Boolean(val));

  // Remove trailing "OR" from the last element if it exists
  if (parts.length > 0) {
    const lastIndex = parts.length - 1;
    parts[lastIndex] = parts[lastIndex].replace(/\s+OR\s*$/, "");
  }

  return parts.filter((val) => Boolean(val) && !isFilterOperator(val));
};
